var _rect, _circle, _path, _rect2, _rect3, _rect4, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifySuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 73,
    viewBox: "0 0 54 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 11.7695,
    width: 46.32,
    height: 60.6571,
    rx: 4,
    fill: "#3eb8aa"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.895,
    cy: 14.895,
    r: 13.895,
    fill: "#3EB8AA",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7383 15.5965L35.8553 19.7135L46.1479 9.4209",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.61719,
    y: 39.7695,
    width: 28,
    height: 2.15385,
    rx: 1.07692,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.61719,
    y: 49.4609,
    width: 23.6923,
    height: 2.15385,
    rx: 1.07692,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.61719,
    y: 59.1543,
    width: 14,
    height: 2.15385,
    rx: 1.07692,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7939 29.6639C16.2722 29.6213 17.4216 27.889 17.3612 25.7947C17.3008 23.7005 16.0534 22.0374 14.5751 22.08C13.0968 22.1227 11.9474 23.8549 12.0078 25.9492C12.0683 28.0434 13.3156 29.7066 14.7939 29.6639Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9883 29.2139C15.9883 29.2139 16.5204 30.2461 17.269 30.4024C18.0177 30.5587 20.2615 31.6009 20.5727 34.0034",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5363 29.2839C13.5363 29.2839 13.0646 30.3452 12.3262 30.5444C11.5878 30.7436 9.40776 31.9134 9.23563 34.3298",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifySuccess);
export default __webpack_public_path__ + "static/media/verify-success.ebac1fc1faf622565ae6d0efe83f2a46.svg";
export { ForwardRef as ReactComponent };